module.exports = {
  src: __webpack_public_path__ + "assets/images/calendar-plus-dark.088d436b8077302f.svg",
  width: 72,
  height: 72,
  toString: function() { return __webpack_public_path__ + "assets/images/calendar-plus-dark.088d436b8077302f.svg"; }
};